import { useState } from "react";
import { useNavigate } from "react-router";
import { UnderconstructionIllustration } from "vega-illustrations";

import { InformativeModal } from "@vega-core/components/Modals/InformativeModal/InformativeModal";
import { usePublicConfig } from "@vega-core/hooks/usePublicConfig";
import { m } from "@vega-core/paraglide/messages";

type Props = {
  onClose?: VoidFunction;
  open: boolean;
};

export const UnknownErrorModal = ({ onClose, open }: Props) => {
  const navigate = useNavigate();
  const [skipModal, setSkipModal] = useState(false);
  const {
    contacts: { helpEmail },
  } = usePublicConfig();

  return (
    <InformativeModal
      data-testid="unknown-error-modal"
      description={
        <p>
          {m.errors_unexpectedErrorOrContactUs()}
          <a
            className="underline text-brand-default"
            href={`mailto:${helpEmail}`}
          >
            {helpEmail}
          </a>
        </p>
      }
      illustration={<UnderconstructionIllustration />}
      isOpen={!skipModal && open}
      onClose={() => {
        onClose && onClose();
        setSkipModal(true);
        navigate("/");
      }}
      secondaryBtnProps={{
        children: m.btn_goToHomepage(),
        variant: "secondary",
        onClick: () => {
          onClose && onClose();
          setSkipModal(true);
          navigate("/");
        },
      }}
      title={m.errors_modalTitle()}
    />
  );
};
